<template>
<popup-base class="push-unblock" @close="closePopup">
  <div slot="header" class="push-unblock__title">
    How to unblock web push notifications?
  </div>

  <div slot="body" class="push-unblock__body-wrap">
      <div class="push-unblock__first-way">
        <div class="push-unblock__big-text">
          The first way to unblock - is to click the identity information icon.
        </div>
        <div class="push-unblock__small-text">
          Click this icon. Opposite "Notifications" select "Always allow on this site" in&nbsp;the&nbsp;drop-down list.
        </div>
        <div class="push-unblock__image"></div>
      </div>
      <div class="push-unblock__second-way">
        <div class="push-unblock__big-text">
          The second way – is to use browser settings.
        </div>
        <div class="push-unblock__small-text">
          Enter "Settings => Content settings". In the Notification section click "Manage exceptions".
          <br>
          Or enter this address to the address line: chrome://settings/contentExceptions#notifications
        </div>
        <div class="push-unblock__image"></div>
      </div>
      <button-el red large left @click="closePopup" class="btn-continue">Continue
        <icon-base red>
          <icon-check />
        </icon-base>
      </button-el>
  </div>
</popup-base>
</template>

<script>
import { IconCheck } from 'Icons';
import PopupBase from 'Common/PopupBase';

export default {
  components: {
    IconCheck,
    PopupBase,
  },
  methods: {
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>

<style lang="scss" scoped>
  $side-padding: 30px;
  .push-unblock {
    &__body-wrap {
      width: 713px;
      padding: 37px $side-padding 60px;
      .push-unblock__big-text {
        @include font(17px, $black-color1, 500);
        line-height: 21px;
        margin-bottom: 25px;
      }
      .push-unblock__small-text {
        @include font(13px, $black-color1);
        line-height: 21px;
      }
    }
    &__first-way {
      .push-unblock__image {
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
        @include attachImage('first-way', 652px, 560px);
        background-size: contain;
        width: 100%;
        margin: 24px auto 60px;
      }
    }
    &__second-way {
      .push-unblock__image {
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
        @include attachImage('second-way', 680px, 510px);
        background-size: contain;
        width: 100%;
        margin: 33px auto 0;
      }
      .push-unblock__small-text {
        margin-right: 30px;
      }
    }
  }
  .btn-continue {
    padding: 10px 10px 11px 18px;
    margin: 60px auto 0;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/alertCreation/PushUnblockPopup.vue